import { render, staticRenderFns } from "./HeaderOrders.vue?vue&type=template&id=8751f86c&scoped=true"
import script from "./HeaderOrders.vue?vue&type=script&lang=js"
export * from "./HeaderOrders.vue?vue&type=script&lang=js"
import style0 from "./HeaderOrders.vue?vue&type=style&index=0&id=8751f86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751f86c",
  null
  
)

export default component.exports